export default __webpack_public_path__ + "./images/et.451d2649.png";